import { useEffect, useRef, useState } from 'react';

import { Toast } from 'primereact/toast';
import { Tree, TreeCheckboxSelectionKeys, TreeEventNodeEvent, TreeMultipleSelectionKeys } from 'primereact/tree';
import { TreeNode } from 'primereact/treenode';
import { useNavigate } from 'react-router-dom';
import configUrls from '../config/configUrls';
import { useOrgaoRoutes } from '../config/useOrgaoRoutes';
import { useSecretariaRoutes } from '../config/useSecretariaRoutes';
import '../styles/menuLateralProcessoSelecionado.css';
import { useSetorRoutes } from '../config/useSetorRoutes';

export function MenuLateral() {
  const orgaoRoutes = useOrgaoRoutes();
  const secretariaRoutes = useSecretariaRoutes();
  const [nodes, setNodes] = useState<TreeNode[]>([]);
  const [selectedNodeKey, setSelectedNodeKey] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null>('');
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();
  const setorRoutes = useSetorRoutes();

  const acompanhamentoEspecial = {
    key: '0',
    label: 'Acompanhamento Especial',
    data: 'acompanhamentoEspecial',
    icon: 'pi pi-fw pi-eye'
  };

  const baseConhecimento = {
    key: '1',
    label: 'Base do Conhecimento',
    data: 'baseConhecimento',
    icon: 'pi pi-fw pi-database'
  };

  const blocos = {
    key: '2',
    label: 'Blocos',
    data: 'baseConhecimento',
    icon: 'pi pi-fw pi-inbox',
    children: [
      { key: '2-0', label: 'Assinatura', data: 'blocos-assinatura' },
      { key: '2-1', label: 'Internos', data: 'blocos-interno' },
      { key: '2-2', label: 'Reunião', data: 'blocos-reuniao' }
    ]
  };

  const controleProcessos = {
    key: '3',
    label: 'Controle de Processos',
    data: 'controleProcessos',
    icon: 'pi pi-fw pi-book',
    link: configUrls.PROCESSO_LIST_RT
  };

  const estatisticas = {
    key: '4',
    label: 'Estatística',
    data: 'estatistica',
    icon: 'pi pi-fw pi-chart-line'
  };

  const favoritos = {
    key: '5',
    label: 'Favoritos',
    data: 'favoritos',
    icon: 'pi pi-fw pi-star-fill'
  };

  const grupos = {
    key: '6',
    label: 'Grupos',
    data: 'grupos',
    icon: 'pi pi-fw pi-users',
    children: [
      { key: '6-0', label: 'Contatos', data: 'grupos-contatos' },
      { key: '6-1', label: 'E-mail', data: 'grupos-email' },
      { key: '6-2', label: 'Envio', data: 'grupos-envio' },
      { key: '6-3', label: 'Federação', data: 'grupos-federacao' }
    ]
  };

  const iniciarProcesso = {
    key: '7',
    label: 'Iniciar Processo',
    data: 'iniciarProcesso',
    icon: 'pi pi-fw pi-plus-circle',
    link: configUrls.PROCESSO_CREATE_RT
  };

  const marcadores = {
    key: '8',
    label: 'Marcadores',
    data: 'marcadores',
    icon: 'pi pi-fw pi-tag'
  };

  const painelControle = {
    key: '9',
    label: 'Painel de Controle',
    data: 'painelControle',
    icon: 'pi pi-fw pi-sliders-v'
  };

  const pesquisa = {
    key: '10',
    label: 'Pesquisa',
    data: 'pesquisa',
    icon: 'pi pi-fw pi-search'
  };

  const pontosControle = {
    key: '11',
    label: 'Pontos de Controle',
    data: 'pontosControle',
    icon: 'pi pi-fw pi-inbox'
  };

  const sobrestados = {
    key: '12',
    label: 'Sobrestados',
    data: 'sobrestados',
    icon: 'pi pi-fw pi-pause'
  };

  const relatorio = {
    key: '13',
    label: 'Relatório',
    data: 'relatorio',
    icon: 'pi pi-fw pi-print'
  };

  const retornoProgramado = {
    key: '14',
    label: 'Retorno Programa',
    data: 'retornoProgramado',
    icon: 'pi pi-fw pi-arrow-right-arrow-left'
  };

  const textoPadrao = {
    key: '15',
    label: 'Texto Padrão',
    data: 'retornoProgramado',
    icon: 'pi pi-fw pi-file'
  };

  const tabelas = {
    key: '16',
    label: 'Tabelas',
    data: 'tabelas',
    icon: 'pi pi-fw pi-users',
    children: [
      { key: '16-1', label: 'Blocos', data: 'blocos', link: configUrls.BLOCO_LIST },
      { key: '16-2', label: 'Grupos Acompanhamento', data: 'grupos-acompanhamentos', link: configUrls.GRUPO_ACOMPANHAMENTO_LIST },
      { key: '16-3', label: 'Marcadores', data: 'marcadores', link: configUrls.MARCADOR_LIST_RT },
      { key: '16-4', label: 'Orgãos', data: 'orgaos', link: orgaoRoutes.ORGAO_LIST },
      { key: '16-5', label: 'Secretarias', data: 'secretarias', link: secretariaRoutes.SECRETARIA_LIST },
      { key: '16-6', label: 'Setores / Dptos', data: 'setor-dptos', link: setorRoutes.SETOR_LIST },
      { key: '16-7', label: 'Tipos Documento', data: 'tipo-Documento', link: configUrls.TIPO_DOCUMENTO_LIST_RT },
      { key: '16-8', label: 'Tipos Processos', data: 'tipo-processo', link: configUrls.TIPO_PROCESSO_LIST_RT }
    ]
  };

  const fetchData = () => {
    const data = [
      acompanhamentoEspecial,
      baseConhecimento,
      blocos,
      controleProcessos,
      estatisticas,
      favoritos,
      grupos,
      iniciarProcesso,
      marcadores,
      painelControle,
      pesquisa,
      pontosControle,
      sobrestados,
      relatorio,
      retornoProgramado,
      textoPadrao,
      tabelas
    ];

    setNodes(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onExpand = (event: TreeEventNodeEvent) => {
    //toast.current && toast.current.show({ severity: 'success', summary: 'Node Expanded ', detail: event.node.label });
  };

  const onCollapse = (event: TreeEventNodeEvent) => {
    //toast.current && toast.current.show({ severity: 'warn', summary: 'Node Collapsed', detail: event.node.label });
  };

  const onSelect = (event: any) => {
    //toast.current && toast.current.show({ severity: 'info', summary: 'Node Selected {event.node.data}', detail: event.node.data });
    if (event.node.link) {
      navigate(event.node.link);
    }
  };

  const onUnselect = (event: TreeEventNodeEvent) => {
    // toast.current && toast.current.show({ severity: 'info', summary: 'Node Unselected', detail: event.node.label });
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="w-[30%] p-2 h-screen bg-slate-300">
        <Tree
          value={nodes}
          selectionMode="single"
          selectionKeys={selectedNodeKey}
          onSelectionChange={e => setSelectedNodeKey(e.value)}
          onExpand={onExpand}
          onCollapse={onCollapse}
          onSelect={onSelect}
          onUnselect={onUnselect}
          filter
          filterMode="strict"
          filterPlaceholder="Localizar no menu"
          className="w-full bg-slate-100 rounded-lg p-4 text-blue-500 custom-tree"
        />
      </div>
    </>
  );
}
